(function () {
  'use strict';

  var COOKIE_NAME = '1818_loaded';
  var COOKIE_DAYS = 14;
  var MIN_DURATION = 2800;
  var BAR_DURATION = 3000;

  function hasCookie() {
    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim().startsWith(COOKIE_NAME + '=');
    });
  }

  function setCookie() {
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_NAME + '=1; path=/; expires=' + expires + '; SameSite=Lax';
  }

  var screen = document.getElementById('loading-screen');

  if (!screen) {
    return;
  }

  var cookieEnabled = screen.dataset.lsEnabled === 'true';

  if (cookieEnabled && hasCookie()) {
    screen.classList.add('ls-hidden');
    return;
  }

  if (sessionStorage.getItem('1818_session')) {
    screen.classList.add('ls-hidden');
    return;
  }
  sessionStorage.setItem('1818_session', '1');

  var bar = document.getElementById('ls-progress-bar');
  var startTime = performance.now();

  function updateBar(now) {
    if (!bar) {
      return;
    }

    var elapsed = now - startTime;
    var progress = Math.min(elapsed / BAR_DURATION, 1);
    var eased = 1 - Math.pow(1 - progress, 3);

    bar.style.width = (eased * 100).toFixed(2) + '%';

    if (progress < 1) {
      requestAnimationFrame(updateBar);
    }
  }

  requestAnimationFrame(updateBar);

  function dismiss() {
    if (cookieEnabled) {
      setCookie();
    }

    screen.classList.add('ls-hiding');

    screen.addEventListener('transitionend', function handler() {
      screen.classList.add('ls-hidden');
      screen.removeEventListener('transitionend', handler);
    });

    setTimeout(function () {
      screen.classList.add('ls-hidden');
    }, 2600);
  }

  var pageReady = false;
  var timerDone = false;

  function tryDismiss() {
    if (pageReady && timerDone) {
      dismiss();
    }
  }

  window.addEventListener('load', function () {
    pageReady = true;
    tryDismiss();
  });

  setTimeout(function () {
    timerDone = true;
    tryDismiss();
  }, MIN_DURATION);
})();
